// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"43c49892","768":"83318536","787":"ab9168d6","972":"6e69f923"}[chunkId] + ".chunk.js";
};